module.exports = __webpack_public_path__ + "img/bg-header-top.8f40f42b.png";